import type { RouteRecordRaw } from 'vue-router'

const BusinessRegistrationPage = () => import('./pages/BusinessRegistrationPage.vue')

const businessRoutes: RouteRecordRaw[] = [
  {
    name: 'business-registration',
    path: '/business-registration',
    component: BusinessRegistrationPage,
    // Same auth posture as business-options-menu: session cookie auth; users may have no active business yet.
  },
]

export default businessRoutes
